<template>
  <div class="hero" :class="{ 'hero--compact': compact }">
    <transition name="trans">
      <div v-if="reveal" class="hero--wrap secondary darken-4">
        <!-- Image -->
        <div v-if="imgSrc" class="hero__img-wrap">
          <div class="hero__img bg--lazy bg--fixed" v-lazy:background-image="getImageUrl(imgSrc, '2400')" />
        </div>
        <!-- Video -->
        <div v-if="bgType === 'vid' && vidSrc" class="hero__vid-wrap">
          <simple-video class="hero__vid" :src="`/assets/videos/${vidSrc}`" autoplay />
        </div>
        <!-- Trans -->
        <div class="hero__trans"></div>
        <!-- Showcase -->
        <div class="hero__showcase pb-12">
          <v-container class="pb-12 pb-sm-8">
            <v-row
              class="justify-space-between"
              :class="{ 'flex-row-reverse': guide.showcaseDir === 'left' }"
              no-gutters
            >
              <!-- Brand Mega -->
              <v-col v-if="guide.component === 'BrandMega'" cols="12" sm="5">
                <brand-mega class="mb-4 mb-sm-0 ml-sm-n3" />
              </v-col>
              <!-- Default Showcase -->
              <v-col v-else cols="11" sm="7" class="mb-6 mb-sm-0">
                <h1 class="hero__showcase-title mb-6 display-4 white--text">{{ guide.title }}</h1>
                <p class="hero__showcase-description secondary--text text--lighten-1">{{ guide.description }}</p>
              </v-col>
              <!-- Arrow -->
              <v-col
                cols="12"
                sm="5"
                class="d-flex align-end mr-n5 mr-sm-0"
                :class="{
                  'justify-end': guide.showcaseDir !== 'left' && !hasMobile,
                  'justify-center': guide.showcaseDir === 'left' && hasMobile
                }"
              >
                <v-btn
                  @click="$vuetify.goTo('.content__wrap', { duration: 1000 })"
                  class="mb-6 mb-sm-0"
                  color="primary"
                  aria-label="الاستمرار"
                  x-large
                  text
                  fab
                >
                  <v-icon size="46">mdi-chevron-down</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </div>
    </transition>
    <!-- Space -->
    <div class="hero__space"></div>
  </div>
</template>

<script>
// deps
import { mapGetters } from 'vuex'
// mixins
import mxHeadMeta from '@/mixins/mx.head.meta'
// components
const SimpleVideo = () => import('@/components/utils/SimpleVideo')
const BrandMega = () => import('@/components/ui/BrandMega')
// export
export default {
  // name
  name: 'Hero',
  // mixins
  mixins: [mxHeadMeta],
  // components
  components: {
    'simple-video': SimpleVideo,
    'brand-mega': BrandMega
  },
  // props
  props: {},
  // data
  data() {
    return {}
  },
  watch: {
    reveal(newValue, oldValue) {
      //console.log('watch reveal', newValue, oldValue)
    }
  },
  // computed
  computed: {
    // mapGetters
    ...mapGetters({ guide: 'getGuide', reveal: 'getGuideReveal' }),
    // compact
    compact() {
      return this.guide.compact
    },
    // bg type
    bgType() {
      return this.guide.featured && this.guide.featured.type === 'vid' ? 'vid' : 'img'
    },
    // image source
    imgSrc() {
      return this.guide.featured ? this.guide.featured.imgSrc : false
    },
    // video source
    vidSrc() {
      return this.guide.featured ? this.guide.featured.vidSrc : false
    }
  },
  // methods
  methods: {}
}
</script>

<style lang="scss">
.hero--wrap,
.hero__vid-wrap,
.hero__vid,
.hero__img-wrap,
.hero__img,
.hero__trans {
  transition: height 350ms ease;
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100vh;
}

.hero__img {
  height: 100vh;
}

.hero--compact .hero--wrap,
.hero--compact .hero__img-wrap,
.hero--compact .hero__img,
.hero--compact .hero__vid-wrap,
.hero--compact .hero__vid,
.hero--compact .hero__trans {
  height: 70vh;
}

.hero__space {
  transition: height 350ms ease;
  min-height: 380px;
}

.hero--wrap {
  overflow: hidden;
}

.hero__img {
}

.hero__trans {
  background: linear-gradient(hsla(0, 0%, 0%, 0.3) 40%, var(--v-secondary-darken5) 105%);
}

.hero__showcase {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
}
.hero__showcase-title {
}

.hero .simple__vid-wrap {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
}

.hero__btm-divider {
  position: relative;
}

// small & down
@include sm-down {
  .hero--wrap,
  .hero__vid-wrap,
  .hero__vid,
  .hero__img-wrap,
  .hero__img,
  .hero__trans {
    min-height: calc(380px + 70px);
  }
  .hero__space {
    height: 100vh;
  }
  .hero--compact .hero__space {
    height: calc(70vh - 70px);
  }
}
// small & up
@include sm-up {
  .hero--wrap,
  .hero__vid-wrap,
  .hero__vid,
  .hero__img-wrap,
  .hero__img,
  .hero__trans {
    min-height: calc(380px + 140px);
  }
  .hero__space {
    height: calc(100vh - 140px);
  }
  .hero--compact .hero__space {
    height: calc(70vh - 140px);
  }
}
</style>
